/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type MedicineAndTreatmentDto = {
    createdBy?: string;
    createdDate?: string;
    lastModifiedBy?: string;
    lastModifiedDate?: string;
    deleted?: boolean;
    id?: string;
    description?: string;
    medicineId?: string;
    examinationId?: string;
    employeeId?: string;
    status?: MedicineAndTreatmentDto.status;
}

export namespace MedicineAndTreatmentDto {

    export enum status {
        DELETED = 'DELETED',
        ACTIVE = 'ACTIVE',
        NURSE_OPERATION = 'NURSE_OPERATION',
        ARCHIVED = 'ARCHIVED',
        PASSIVE = 'PASSIVE',
    }


}
